import {useRef, type RefObject} from 'react';

import {useOnMount} from 'shared/web';

import {useEagGridStore} from '../../store/useEagGridStore';
import {preserveGridMaximizationScroll} from './utils/preserveGridMaximizationScroll';

/** Removing the capability resets transient state without replacing the mounted grid. */
export function GridMaximizationAvailability(props: {
  surfaceRef: RefObject<HTMLDivElement | null>;
}) {
  const store = useEagGridStore();
  const cleanupRef = useRef<VoidFunction | undefined>(undefined);
  useOnMount(
    () => {
      const surface = props.surfaceRef.current;
      if (surface) {
        cleanupRef.current = preserveGridMaximizationScroll(surface, store);
      }
    },
    () => {
      store.setIsMaximized(false);
      cleanupRef.current?.();
    }
  );
  return null;
}
